import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../Button'

import * as styles from './PdfViewerToolbarButton.module.css'

function PdfViewerToolbarButton({
  disabled,
  iconProps,
  isActive,
  qaName,
  titleKey,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Flat
      isGrey
      beforeIconProps={iconProps}
      className={styles.PdfViewerToolbarButton}
      disabled={disabled}
      height={BUTTON_HEIGHT_32}
      isActive={isActive}
      qaName={qaName}
      tooltip={t(titleKey)}
      onClick={onClick}
    />
  )
}

export default PdfViewerToolbarButton
